// Effect Managers
import { call, fork } from 'redux-saga/effects'

// Controller
import controller from 'fc-ctrl-environment'

// Exports
export default function *start () {
  yield call(controller.start)
  yield fork(controller.watch)
  yield call(controller.read)
}
